<template>
  <div class="custom-tag-select">
    <div
      v-for="item in listNew"
      :key="item.key"
      class="tag-item">
      <el-tag
        size="medium"
        :effect="getEffect(item.selected)"
        @click="onClickTag(item)">{{ item.label }}</el-tag>
    </div>
  </div>
</template>
<script>
import Common from '@/service/common'
export default {
  name: 'CustomTagSelect',
  props: {
    k: { type: String, default: '' },
    value: { type: Array, default: () => [] },
    max: { type: Number, default: 3 }
  },
  data() {
    return {
      config: { topic: 'sgs' },
      list: []
    }
  },
  computed: {
    selection: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    listNew({ list, selection }) {
      return list.map((label, key) => ({ label, key, selected: selection.includes(label) }))
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    getEffect(selected) {
      return selected ? 'dark' : 'plain'
    },
    onClickTag(item) {
      const { selected, label } = item
      if (!selected) {
        const size = this.listNew.filter(i => i.selected).length
        if (size >= this.max) {
          this.$message.error(`最多选择${this.max}个`)
        } else {
          this.selection.push(label)
        }
      } else {
        const index = this.selection.findIndex(i => i === label)
        this.selection.splice(index, 1)
      }
    },
    init() {
      Common.getkeyvaluebykey({ ...this.config, k: this.k })
        .then(res => {
          const { result, message, v } = res.data
          if ([0].includes(result)) {
            this.list = JSON.parse(v)
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
.tag-item {
  display: inline-block;
  vertical-align: top;
  cursor pointer
  /deep/.el-tag {
    vertical-align: top;
  }
}
.tag-item+.tag-item {
  margin-left: 5px;
}
</style>
